module.exports = __webpack_public_path__ + "static/media/gradually_launch.51e81f71.png";